import { useNavigation } from '@hotjar/navigation';

/**
 * Hook that returns the height of the top navbar.
 *
 * @deprecated use const { topBarHeight } = useNavigation(); instead.
 */
export const useTopNavHeight = (): number => {
  const { topBarHeight } = useNavigation();

  return topBarHeight;
};
